export const BASE_URL = "https://dev-app-service2020.azurewebsites.net";
// export const BASE_URL = "";
